import ButtonRadioElement from 'components/AtomicStructure/atoms/ButtonRadioElement';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Title from 'ui-library/components/Title/Title';
import Loader from 'ui-library/components/Loader/Loader';
import { ProposalSummaryItem } from './ProposalSummaryItem';
import './FinalizeProposal.css';

const FinalizeProposal = ({ datasource }) => {
    const { t } = useTranslation();

    const { dfsClientId } = useParams();

    const {
        languagesOption,
        handleSelectLanguage,
        error,
        selectedLanguage,
        proposals,
        proposalLoading,
    } = datasource({
        dfsClientId,
    });

    return (
        <div>
            <div className="select-document-language">
                <ButtonRadioElement
                    data-cy="documentLanguage"
                    label={t(
                        'portfolio.createNewPortfolio.opening.documentLanguage',
                    )}
                    items={languagesOption}
                    error={error?.documentLanguage}
                    passData={handleSelectLanguage}
                    value={selectedLanguage?.id}
                    nameData="documentLanguage"
                    wrapperClassName="buttonRadioElementWrapper"
                />
            </div>

            <Title type={2} className="font-normal mt-60">
                {t('portfolio.createNewProposal.opening.proposalSummary')}
            </Title>

            {proposalLoading ? (
                <div className="proposal-summary-data">
                    <Loader />
                </div>
            ) : (
                <div className="proposal-summary-data">
                    {proposals?.map((proposal) => (
                        <ProposalSummaryItem
                            proposalType={proposal?.proposalType}
                            threeBProductName={proposal?.threeBProductName}
                            proposalOwner={proposal?.proposalOwner}
                            productGroupType={proposal?.productGroupType}
                            advisorName={proposal?.advisorName}
                            agentName={proposal?.agentName}
                            selectedLanguage={selectedLanguage?.label}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default FinalizeProposal;
